module.exports = __webpack_public_path__ + "media/backgrounds/bob-brewer-mov3YIkS4Lg-unsplash-aa6369c5.jpg";